import { render, staticRenderFns } from "./SearchColor.vue?vue&type=template&id=7a608e9d&"
import script from "./SearchColor.vue?vue&type=script&lang=ts&"
export * from "./SearchColor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports